import { get } from 'lodash-es';

import type { TranslationKeyArg, TranslationPluralKeyArg, Translations } from '../shared/types';

export function translationExists(translations: readonly Translations[], key: TranslationKeyArg): boolean {
	const value = translations.reduce<string | Translations | null>(
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		(acc, dic) => acc ?? get(dic, key as string) ?? null,
		null,
	);
	return typeof value === 'string';
}

export function translationPluralExists(translations: readonly Translations[], key: TranslationPluralKeyArg): boolean {
	const value = translations.reduce<string | Translations | null>(
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		(acc, dic) => acc ?? get(dic, key as string) ?? null,
		null,
	);
	return !!value && typeof value === 'object' && 'other' in value;
}
